import React, { useEffect } from 'react';
import { datadogRum } from '@datadog/browser-rum';
import { AnalyticEvents } from '@constants/index';
import { Analytics } from '@services/analytics-service';
import { useRouter, ROUTES } from '../../providers/router';
import { SelectionList } from '../../components/selection-list';
import { Levels } from '../../constants';

export const SubSubCategories = () => {
  useEffect(() => {
    Analytics.trackEvent(AnalyticEvents.sarSubSubCategoryViewed);
    datadogRum.addAction(AnalyticEvents.sarSubSubCategoryViewed);
  }, []);

  const { completeFormStep } = useRouter();

  const handleNextRoute = (dataSubset: any) => {
    completeFormStep(ROUTES.SUB_SUB_CATEGORIES, dataSubset);
  };

  return <SelectionList level={Levels.Subsubcategory} handleNextRoute={handleNextRoute} />;
};

export default SubSubCategories;
